export default __webpack_public_path__ + "static/media/login.34fc24b3.jpeg";